export default "__VITE_ASSET__BRRi8L89__"